import { useEffect, useState, useContext } from 'react'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Pagination from '../../components/pagination';
import { getTemplatesApi, deleteTemplateApi } from '../../api'
import { AuthContext } from '../../context/auth';
import moment from 'moment/moment';
import DeleteTemplateModal from "../../components/modals/DeleteTemplateModal"
import AddTemplateModal from "../../components/modals/addTemplateModal"

const Index = () => {
  const { setIsLoading, setNotification, isLoading } = useContext(AuthContext)
  const [templates, setTemplates] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteTemplateModal, setDeleteTemplateModal] = useState(false)
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  const fetchTemplates = () => {
    setIsLoading(true)
    getTemplatesApi(10, currentPage * 10).then(res => {
      if (res && res.data) {
        setTemplates(res?.data)
        setIsLoading(false)
      }
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    fetchTemplates()
  }, [currentPage])


  const onDeleteTemplate = () => {
    setIsLoading(true)
    deleteTemplateApi(selectedTemplate?.id).then(() => {
      fetchTemplates()
      setDeleteTemplateModal(false)
      setOpenTemplateModal(false)
      setSelectedTemplate(null)
      setIsLoading(false)
      setNotification({ type: 'success', message: 'Template deleted successfully' })
    }).catch(err => {
      setIsLoading(false)
      setNotification({ type: 'error', message: 'Something went wrong' })
    })
  }

  const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || "";
};

  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>Templates</span>{templates?.count}</div>
        <div className="header-search-container">
          <button className='btn' onClick={() => setOpenTemplateModal(true)}>Add New Template</button>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        {templates && templates?.count > 0 ? <>
          <table className={"mainTable"}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Template Category</th>
                <th>Content</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {templates?.templates?.map((data) => {
                const previewTemplate = stripHtml(data?.template)?.slice(0, 190) + "…"
                return (
                  <tr
                    key={data?.id}
                  >
                    <td>
                      <strong>{data?.name}</strong>
                    </td>
                    <td>
                     {data?.category?.name || '-'}
                    </td>
                    <td style={{ maxWidth: "300px", whiteSpace: "wrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {previewTemplate}
                    </td>
                    <td>
                      {data?.created_at ? moment(data?.created_at).format('MMMM DD, YYYY, h:mm A') : "-"}
                    </td>
                    <td style={{ cursor: "pointer" }}>
                      <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                          setSelectedTemplate(data)
                          setOpenTemplateModal(true)
                        }}><i class="fal fa-pencil"></i></button>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }}
                          onClick={() => {
                            setSelectedTemplate(data)
                            setDeleteTemplateModal(true)
                          }}
                        ><i class="fal fa-trash-alt"></i></button>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {templates?.count / templates?.limit > 1 && <Pagination total={templates?.count / templates.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
        </>
          : <div className='no-orders'>
            <span className='icon'>
              <i class="far fa-boxes"></i>
            </span>
            <p>No Templates found.</p>
          </div>
        }
      </ContentWrapper>
      {openTemplateModal && <AddTemplateModal setOpenTemplateModal={setOpenTemplateModal} selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} fetchTemplates={fetchTemplates} setDeleteTemplateModal={setDeleteTemplateModal} />}
      {(deleteTemplateModal && selectedTemplate) && <DeleteTemplateModal selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} setDeleteTemplateModal={setDeleteTemplateModal} onDelete={onDeleteTemplate} isLoading={isLoading} />}
    </Layout>
  )
}

export default Index